import {Layout, Anchor, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Link} = Anchor;
const {Sider} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const MedalCLogic = () => {
  return (
    <Layout>
      <Sider>
        <Anchor onClick={handleClick} style={{background: appColors['ColorBack2']}}>
          <Link href='#MedalC' title={<Text className='TextEducation'>MedalC</Text>}/>
        </Anchor>
      </Sider>
      <Layout style={{margin: '-16px 0 0 0'}}>
        <div id='MedalC'>
          <Layout style={{minHeight: '500px'}}>
            <Layout style={{background: appColors['ColorA'], margin: '0 100px 0 100px'}}>
              <Text>Medal Criteria</Text>
            </Layout>
          </Layout>
        </div>
      </Layout>
    </Layout>
  );
};

export default MedalCLogic;
